import "bootstrap-datepicker";

/**
 * When the trigger is clicked, the target element will slide open/closed with animation.
 *
 * @param {string|HTMLElement|jQuery} trigger - Selector for the clickable toggle
 * @param {string} target - Selector for the element that open/close
 * @param {string} wrapper - Selector for the wrapper that contains both the trigger and the target
 */
export function bindToggle(trigger, target, wrapper) {
  const $trigger = $(trigger);

  $trigger.on("click", function (e) {
    e.preventDefault();
    $trigger
      .closest(wrapper)
      .find(target)
      .stop("true", "true") //  'stop' prevents animation stacking if the user clicks repeatedly
      .slideToggle(300);
  });
}

/**
 * Smoothly scrolls the page to a specified element with an offset from the top.
 *
 * @param {jQuery} $element - jQuery object of the target element to scroll to
 */

export function scrollToPosition($element) {
  $("html, body").animate(
    {
      scrollTop: $element.offset().top - 50, // offset a little from the top
    },
    200
  );
}

/**
 * Displays an error message at the top of the page and scrolls to it.
 * Shows the error block and updates its text content.
 *
 * @param {string} errMsg - The error message to display
 */

export function showErrorsAtTop(errMsg) {
  const $errorBlock = $(".js-error-block");
  $errorBlock.find("div").text(errMsg);
  $errorBlock.removeClass("d-none");
  scrollToPosition($errorBlock);
}

/**
 * Resets the error message block to its initial state.
 * Clears the error message and hides the error block.
 */
export function resetErrorBlock() {
  const $errorBlock = $(".js-error-block");
  $errorBlock.find("div").text("");
  $errorBlock.addClass("d-none");
}

/**
 * Scrolls the page to the first form error if any exists.
 * Used to bring validation errors into view.
 */
export function scrollToErrorBlock() {
  const $firstError = $(".form-control--error:not(span)").first();

  if ($firstError.length) {
    scrollToPosition($firstError);
  }
}

/**
 * Configuration object for the date picker.
 * Sets auto-close, date format and prevents future date selection.
 *
 * @type {Object}
 */
const dpDobSettings = {
  autoclose: true,
  format: "dd/mm/yyyy",
  endDate: new Date(), // Prevent selecting future dates
};

$(".js-datepicker").datepicker(dpDobSettings);

/**
 * Attempts to parse a JSON string and returns the resulting object.
 * Logs an error if parsing fails.
 *
 * @param {string} str - The JSON string to parse
 * @returns {Object|undefined} The parsed JSON object or undefined if parsing fails
 */
export function parseJSON(str) {
  try {
    const jsonObj = JSON.parse(str);
    return jsonObj;
  } catch (err) {
    console.error("Invalid syntax");
  }
}

/**
 * Removes the time portion from date values in date picker inputs.
 * Processes all elements with the js-datepicker class.
 * Used when displaying dates that might include time components.
 */
export function removeTimeFromDate() {
  $(".js-datepicker").each(function () {
    const value = $(this).val();
    if (value) {
      const datePart = value.split(/[ T]/)[0]; // splits on space or "T"
      $(this).val(datePart);
    }
  });
}
